<template>
  <div>
    <v-app-bar color="transparent" elevation="0" height="100" max-height="100">
      <div class="container px-0 px-md-3">
        <img src="https://creditclan.com/images/logo-small.png" alt="cc logo" style="width: 130px"/>
      </div>
    </v-app-bar>
    <div class="container">
      <div class="mb-6">
        <h2>Consumer Terms & conditions</h2>
        <p>Last Update: July 20, 2021</p>
      </div>
      <p>
        These terms and conditions apply between you, the User of Ceecee (Creditclan WhatsApp chatbot) and Website
        (including any sub-domains, unless expressly excluded by their own terms and conditions), and Creditclan
        Technology Limited, the owner and operator of this Website. Please read these terms and conditions carefully, as
        they affect your legal rights. Your agreement to comply with and be bound by these terms and conditions is
        deemed to occur upon your first use of the Website. If you do not agree to be bound by these terms and
        conditions, you should stop using the Website immediately.
      </p>
      <ul>
        <li>1. Introduction</li>
        <li>
          1.1 The Parties to this Agreement.
          <ul>
            <li>
              These are the terms and conditions (the "Terms and Conditions") that apply to your access to, and use of,
              Creditclan.com ("Platform", "Services") and Creditclan WhatsApp chatbot known as “Ceecee” developed and
              owned by Creditclan Technology Limited ("we", "us" and "our" and includes our officers, employees,
              contractors, agents, successors, and assignees). Accordingly, please read these terms and conditions
              carefully.
            </li>
            <li>
              Where we refer to "you" or "your" in these Terms and Conditions, we mean any individual using the Platform
              and engaging Ceecee, Creditclan WhatsApp chatbot.
            </li>
            <li>
              Where we also refer to “Merchants” in these terms and conditions, we mean any individual who signs up to
              use the platform to sell.
            </li>
            <li>
              Where we refer to “buyers/customers” in these terms and conditions, we mean any individual who buys goods
              and services from the “merchants” and also engages the Creditclan WhatsApp chatbot to buy goods and
              services from the “merchants”.
            </li>
            <li>
              Where we refer to “financial partners” in these terms and conditions, we mean any individual/institution
              who partners with Creditclan technology limited to finance credit transactions.
            </li>
            <li>
              By accessing and using the Platform, you acknowledge you have read, and agree to comply with, these Terms
              and Conditions. If you do not wish to be bound by these Terms and Conditions, do not download, access, or
              use the Platform.
            </li>
          </ul>
        </li>
        <li>
          1.2 Changes to this Agreement.
          <p>
            We reserve the right to amend these Terms and Conditions, in whole or in part, for any reason at any time.
            If we amend these Terms and Conditions the amendments will be effective immediately upon posting of the
            amended Terms and Conditions on our website and the date at the beginning of these Terms and Conditions will
            be updated to the date such amendments take effect. We will also email you with a link to the new Terms and
            Conditions. Any amendments we make do not change the Terms and Conditions of a purchase made using the
            Platform and the payment of the Purchase Price that applied at the time of the purchase. You are responsible
            for checking, and ensuring you are familiar with, the latest Terms and Conditions applicable at the date of
            purchase. Your continued use of the Platform after any amendments are made will be confirmation of your
            acceptance of these Terms and Conditions as amended.
          </p>
        </li>
        <li>
          1.3 Your Eligibility
          <p>
            To be eligible to use Creditclan.com, you are at least the age of majority in your state or province of
            residence and are legally capable of entering into a binding contract. However, Creditclan.com may only be
            used in Nigeria at the moment. You must be 18 years old or above to use Creditclan.com and Ceecee.
            Creditclan.com may change these eligibility requirements at any time and reserves the right to refuse
            membership to any applicant for any reason, at its sole discretion.
          </p>
        </li>
        <li>2. Your Account</li>
        <li>
          2.1 Opening of User Account.
          <p>
            To become a User of Creditclan.com Services, you must register and create an account on Creditclan.com
            either through web or Ceecee, Creditclan WhatsApp chatbot. By opening a User Account and accepting the terms
            as outlined in this Agreement, you attest that you are establishing the Account to enable yourself to use
            Creditclan.com to sell goods and services on credit and full payment, finance & purchase goods, and services
            from other merchants on Ceecee and Creditclan.com.
          </p>
          <ul>
            <li>
              When you first use the Platform, you will be required to provide certain login information (including
              business information, first name, last name, email, and password) that will enable you to access the
              Platform each time you wish to use the Platform to purchase products or services. You must keep your
              log-in information secure to avoid the use of the Platform using your log-in details by other persons.
            </li>
            <li>
              You must not permit the use of the Platform using your log-in details by any other person. If the Platform
              is used by any other person with your log-in details, or if you know or suspect any other person has
              obtained your log-in details, you must immediately notify us at care@creditclan.com.
            </li>
            <li>
              You must exercise every possible care to ensure the safety of your computer or mobile device by taking all
              reasonable care to prevent loss, theft, and unauthorized or fraudulent use.
            </li>
            <li>
              If the Platform is used by another person to sell illegal Products or Services, you will be personally
              liable and handed over to the appropriate authority in accordance with these Terms and Conditions.
            </li>
            <li>
              Buyers also become users when they engage in any transaction with merchants and any of the Creditclan
              partners on either creditclan.com or Ceecee, the Creditclan WhatsApp chatbot.
            </li>
          </ul>
        </li>
        <li>
          2.2 Account Activation
          <p>
            To create an account on Creditclan.com, we may require that you provide us with your mobile phone number and
            prove that you have possession of that device by confirming registration via your email provided. User
            identification properties that we ask for include, but are not limited to, first and last name, address, and
            date of birth. We may also ask you to provide us with your Bank Verification Number (BVN) and National
            Identification Number (NIN). To finalize your User Account creation, we may ask you to link a bank account
            to your User Account on Creditclan.com.
          </p>
        </li>
        <li>
          2.3 Account Security
          <p>
            Creditclan.com identifies User Accounts by the mobile phone number or the email linked to the User Account.
            The platform also ensures users confirm their registration via the email provided.
          </p>
        </li>
        <li>
          3. Sell on Credit/Buy on credit
        </li>
        <li>
          3.1 The "Sell on credit" and “Buy on credit” Service.
          <p>
            Creditclan "Sell on Credit" is a closed-end installment loan product with standard terms of 1 - 12 months
            offered by merchants (registered users) on Creditclan.com and Creditclan’s financial partners and powered by
            Creditclan’s credit infrastructure. Loan term options and condition are strictly based on the decision of
            the finance houses powering the transaction and also on the terms and condition of the merchant who wish to
            sell on credit at his or her own risk. "Sell on credit" allows “Merchants” to sell goods or services on
            credit for personal and business use while their respective buyers/customers pay back in installments. If
            you agree to use "Sell on credit," creditclan.com will conduct credit analysis on your buyers/customers who
            want to “buy on credit” and on you should you decide to apply for loans to boost your business. Financial
            partners pay you for goods or services on behalf of your buyers/customers who buy on credit from you if you
            activate the financial partners to take charge of products and services sold on credit. The terms of the
            loan are subject to Creditclan credit assessment.
          </p>
          <p>
            Merchants are liable for customer complaints and returns as regards goods and services sold.
          </p>
        </li>
        <li>
          3.2 Your Promise to Pay
          <p>
            By accepting this Agreement and confirming any form of financing/loan through Creditclan’s finance partners
            on Creditclan.com, you give Creditclan technology unlimited right to collect any unpaid portions of the loan
            owed.
          </p>
        </li>
        <li>
          3.3 Interest Rates
          <p>
            Business loan "Sell on credit" rates range from 2% to 10% fixed monthly rate, depending on your
            creditworthiness and it is strictly at the discretion of the financial partner’s terms and conditions.
          </p>
          <p>
            The finance of products and services which is otherwise known as “buy on credit” is done by Creditclan’s
            partners and the interest is determined by the same partners’ terms and conditions. Buyers’ transactions are
            funded by Creditclan’s partners.
          </p>
        </li>
        <li>
          3.3 Creditclan’s Role in the transaction
          <p>
            Creditclan is not engaged in the sale of any goods or services. Creditclan does not have control of, or
            liability for, the products or services sold by merchants or transactions financed through finance partners.
            Creditclan provides an online platform that allows consumers, Merchants, and Creditclan to connect at the
            point of purchase.
          </p>
          <p>
            We provide a service that allows you: sell products and services on outright payment or credit, access loans
            through our financial partners, recover payments for products/services sold on credit through our collection
            services, run credibility analysis on buyers/customers buying credit. If you have a dispute, you shall lodge
            your complaints to care@creditclan.com.
          </p>
        </li>
        <li>
          3.5 Permission to obtain credit reports
          <p>
            Agreeing to these terms and conditions means you authorize Creditclan to obtain credit reports from
            financial institutions, credit institutions, and other relevant institutions on behalf of your customers for
            credit analysis.
          </p>
        </li>
        <li>
          3.6 Refunds and Cancellations
          <p>
            When buyers accept the final terms of the Creditclan Services at any Merchant location or website, and by
            entering into a loan agreement, buyers are agreeing to repay the loan to Creditclan based on the terms and
            conditions of buyers’ loan agreement, unless the loan is not issued. Once the loan has been issued, buyers
            are responsible for making the payments pursuant to their loan agreement.
          </p>
          <p>
            Refunds and cancellations are subject to the return and refund policies/agreements of Merchants. Buyers must
            contact their Merchant directly to resolve conflict.
          </p>
          <p>
            If a refund or cancellation is processed between buyers and the Merchant after the loan has been issued, the
            Merchant shall be liable to the buyer either for refund or cancellation while the terms and conditions of
            the loans remain. Any disputes as to the adjusted amount of the loan are to be resolved between buyers and
            the Merchants unless the adjusted amount of the loan is the result of an error.
          </p>
          <p>
            If a refund or cancellation is for the entirety of the borrowed amount, you may be charged some fee by
            Creditclan depending on when the merchant notifies us of the refund or cancellation.
          </p>
        </li>
        <li>
          4.4 Service Charge
          <p>
            For the "Sell on credit” service, we charge merchants a 5% transaction fee for every product/service sold on
            credit.
          </p>
        </li>

        <li>5. Liability</li>
        <li>
          5.1 Your Liability
          <p>
            Creditclan is not in any way responsible for the goods or services sold by the merchants to the
            buyers/customers.
          </p>
          <p>
            Creditclan is not liable for the images uploaded by merchants on Creditclan.com
          </p>
        </li>
        <li>
          5.3 Actions by Creditclan - Restricted Activities.
          <p>
            If Creditclan, in its sole discretion, believes that you may have engaged in any Restricted Activities, we
            may take various actions to protect Creditclan, finance partners, other Users. The actions we may take
            include but are not limited to the following:
          </p>
          <ul>
            <li>
              We may close, suspend, or limit your access to your Account (such as limiting your ability to receive
              payment, receive a loan, make withdrawals, or remove financial Information);
            </li>
            <li>
              We may contact other Merchants and buyers you have interacted with, contact your bank, and warn other
              Users, law enforcement, or impacted third parties of your actions;
            </li>
            <li>We may update inaccurate Information you provided us;</li>
            <li>We may refuse to provide any or all creditclan Services to you in the future;</li>
            <li>We may take legal action against you; and</li>
          </ul>
          <p>
            Creditclan, in its sole discretion, reserves the right to terminate this Agreement, your access to its
            website, your access to Creditclan, and all other Creditclan Services for any reason and at any time upon
            notice to you.
          </p>
        </li>
        <li>
          5.4 Actions by Creditclan - Court Orders or Other Legal Processes.
          <p>
            Creditclan, in its sole discretion, may take various actions including any limitation on your Account in the
            event it receives notice of a court order or other legal process that restricts the use of or access to your
            Account. Creditclan will give notice of a limitation it makes to comply with a court order or other legal
            process unless the court order or other process directs that Creditclan does not provide you notice, in
            which case the court order or other process supersedes any notice obligation Creditclan has undertaken or
            agreed to under the terms of this Agreement. Creditclan has no obligation to contest or appeal from any such
            order or process. Creditclan will decide in its sole discretion the appropriate scope of a limitation to
            assure compliance with a court order or other legal process.
          </p>
        </li>
        <li>
          5.5 Limitations of Liability.
          <p>

            IN NO EVENT SHALL WE, OUR PARENT AND AFFILIATES, AND THE OFFICERS, DIRECTORS, AGENTS, JOINT VENTURERS,
            EMPLOYEES, AND FINANCE PARTNERS OF CREDITCLAN BE LIABLE FOR LOST PROFITS OR ANY SPECIAL, INCIDENTAL, OR
            CONSEQUENTIAL DAMAGES (INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF DATA OR LOSS OF BUSINESS) ARISING
            OUT OF OR IN CONNECTION WITH OUR WEBSITE, THE CREDITCLAN SERVICES, OR THIS AGREEMENT (HOWEVER ARISING,
            INCLUDING NEGLIGENCE), UNLESS AND TO THE EXTENT PROHIBITED BY LAW. OUR LIABILITY, AND THE LIABILITY OF OUR
            PARENT AND AFFILIATES, AND OUR AND THEIR RESPECTIVE OFFICERS, DIRECTORS, AGENTS, JOINT VENTURERS, EMPLOYEES,
            AND FINANCE PARTNERS, TO YOU OR ANY THIRD PARTIES IN ANY CIRCUMSTANCE IS LIMITED TO THE ACTUAL AMOUNT OF
            DIRECT DAMAGES. IN ADDITION, TO THE EXTENT PERMITTED BY APPLICABLE LAW, CREDITCLAN, OUR PARENT, AND
            AFFILIATES, AND THEIR RESPECTIVE OFFICERS, DIRECTORS, AGENTS, JOINT VENTURERS, EMPLOYEES, AND FINANCE
            PARTNERS ARE NOT LIABLE, AND YOU AGREE NOT TO HOLD THESE PARTIES RESPONSIBLE, FOR ANY DAMAGES OR LOSSES
            (INCLUDING, BUT NOT LIMITED TO, LOSS OF MONEY, GOODWILL, OR REPUTATION, PROFITS, OR OTHER INTANGIBLE LOSSES
            OR ANY SPECIAL, INDIRECT, OR CONSEQUENTIAL DAMAGES) RESULTING DIRECTLY OR INDIRECTLY FROM: (1) YOUR USE OF
            OR YOUR INABILITY TO USE CREDITCLAN.COM AND SERVICES; (2) DELAYS OR DISRUPTIONS IN CREDITCLAN.COM SITES
            AND SERVICES; (3) VIRUSES OR OTHER MALICIOUS SOFTWARE OBTAINED BY ACCESSING CREDITCLAN.COM SITES OR SERVICES
            OR ANY SITE OR SERVICE LINKED TO CREDITCLAN.COM OR SERVICES; (4) GLITCHES, BUGS, ERRORS, OR INACCURACIES OF
            ANY KIND ON CREDITCLAN.COM SITES OR SERVICES OR IN THE INFORMATION AND GRAPHICS OBTAINED FROM THEM; (5) THE
            CONTENT, ACTIONS, OR INACTIONS OF THIRD PARTIES; (6) A SUSPENSION OR OTHER ACTION TAKEN WITH RESPECT TO YOUR
            ACCOUNT; (7) YOUR NEED TO MODIFY PRACTICES, CONTENT, OR BEHAVIOR, OR YOUR LOSS OF OR INABILITY TO DO
            BUSINESS, AS A RESULT OF CHANGES TO THIS USER AGREEMENT OR CREDITCLAN’S POLICIES. CREDITCLAN RESERVES THE
            RIGHT TO MODIFY ITS POLICIES AND THIS USER AGREEMENT AT ANY TIME CONSISTENT WITH THE PROVISIONS OUTLINED
            HEREIN.
          </p>
        </li>
        <li>6. Disputes with Creditclan.</li>
        <li>
          6.1 Creditclan Contact.
          <p>
            If a dispute arises with Creditclan, our goal is to learn about and address your concerns as soon as
            possible. Disputes with Creditclan regarding the Creditclan Services may be reported to care@creditclan.com
            or by calling from 9 AM to 5 PM GMT+1.
          </p>
        </li>
        <li>
          6.2 Applicable Law.
          <p>
            These Terms of Use shall be interpreted and governed by the laws currently in force in the Federal Republic
            of Nigeria.
          </p>
        </li>
        <li>
          6.3 Legal Disputes.
          <p>
            We shall make an effort to settle all disputes amicably. Any dispute arising out of this Agreement that
            cannot be settled, by mutual agreement/negotiation within 1 (one) month shall be referred to arbitration by
            a single arbitrator at the Lagos Multi-Door Courthouse (“LMDC”) and governed by the Arbitration and
            Conciliation Act, Cap A10, Laws of the Federal Republic of Nigeria. The arbitrator shall be appointed by
            both of us (we and you), where both of us are unable to agree on the choice of an arbitrator, the choice of
            arbitration shall be referred to the LMDC. The findings of the arbitrator and subsequent award shall be
            binding on both of us. Each of us shall bear our respective costs in connection with the Arbitration. The
            venue for the arbitration shall be Lagos, Nigeria.
          </p>
        </li>
        <li>
          6.4 Indemnification.
          <p>
            You agree to defend and indemnify us, and hold us and our affiliates harmless, and our and their respective
            directors, officers, agents, contractors, and employees against any losses, liabilities, claims, expenses
            (including legal fees) in any way arising from, related to or in connection with your use of our website,
            your violation of the Terms, or the posting or transmission of any materials on or through the website by
            you, including but not limited to, any third party claim that any information or materials provided by you
            infringe upon any third-party proprietary rights.
          </p>
        </li>
        <li>
          6.5 No Waiver.
          <p>
            Our failure to act with respect to a breach by you or others does not waive our right to act with respect to
            subsequent or similar breaches.
          </p>
        </li>
        <li>
          6.6 Severability.
          <p>
            If any portion of these Terms of Use is held by any court or tribunal to be invalid or unenforceable, either
            in whole or in part, then that part shall be severed from these Terms of Use and shall not affect the
            validity or enforceability of any other part in this Terms of Use.
          </p>
        </li>
        <li>7. General Provisions</li>
        <li>
          7.1 Assignment.
          <p>
            You may not transfer or assign any rights or obligations you have under this Agreement without Creditclan's
            prior written consent. Creditclan reserves the right to transfer or assign this Agreement or any right or
            obligation under this Agreement at any time.
          </p>
        </li>
        <li>
          7.2 Complete Agreement.
          <p>
            This Agreement, along with any applicable policies and agreements on the Legal Agreements page on the
            Creditclan website, sets forth the entire understanding between you and Creditclan with respect to the
            Creditclan Services. Sections that by their nature should survive will survive the termination of this
            Agreement. Unless stated otherwise in this Agreement, if any provision of this Agreement is held to be
            invalid or unenforceable, such provision shall be struck, and the remaining provisions shall be enforced
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsAndConditions"
}
</script>

<style scoped>

p {
  color: #666;
  margin-top: 10px;
  margin-bottom: 10px;
}

ul li {
  margin-top: 10px;
  margin-bottom: 10px;
}

</style>
